import { Alert, Stack } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { RailVisitPlanningViewStore } from '../../stores/RailVisitPlanningViewStore'

type Props = {
  railVisitPlanningViewStore: RailVisitPlanningViewStore
}

export const RailVisitPlanningWarnings: FC<Props> = observer(props => {
  const { t } = useTranslate()
  const { railVisitPlanningStore } = usePlanningStore()

  const isRailTrackWithDuplicateRailcars = railVisitPlanningStore.railTrackWithDuplicateRailcars
  const { railVisitPlanningViewStore } = props

  return (
    <Stack>
      {isRailTrackWithDuplicateRailcars && (
        <Alert severity='warning'>
          {t(
            'thereAreCurrentlyDuplicatedRailcarsInThisRailVisitPleaseCorrectThemBeforeMakingAnyChanges',
            'There are currently duplicated railcars in this Rail Visit. Please correct them before making any changes',
          )}
        </Alert>
      )}
      {railVisitPlanningViewStore.isRailcarLengthSumExceedsAnyRailtrackLength && (
        <Alert severity='warning'>
          {t(
            'railcarLengthHigherThanTrackLength',
            'Total length of railcars allocated to track exceeds the length of the rail track',
          )}
        </Alert>
      )}
      {railVisitPlanningViewStore.isAnyRailcarOfVisitWithoutLength && (
        <Alert severity='warning'>
          {t(
            'railcarLengthMissing',
            'Unable to calculate the train length due to railcars with missing lengths',
          )}
        </Alert>
      )}
    </Stack>
  )
})
